import React from 'react';
import { Link } from 'react-router-dom';
import { LogOut, ChevronRight, Heart, BarChart3 } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

export const AccountSidebar = ({
  tabs,
  activeTab,
  setActiveTab,
  wishlistCount,
  isShopOwner,
  onLogout,
}) => {
  return (
    <Card className="bg-purple-800/50 border-purple-600">
      <CardContent className="p-4">
        <nav className="space-y-2">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full flex items-center justify-between px-4 py-3 rounded-lg transition-all ${
                  activeTab === tab.id
                    ? 'bg-yellow-500 text-purple-900'
                    : 'text-purple-200 hover:bg-purple-700/50'
                }`}
                data-testid={`tab-${tab.id}`}
              >
                <span className="flex items-center gap-3">
                  <Icon className="w-5 h-5" />
                  {tab.label}
                </span>
                <ChevronRight className="w-4 h-4" />
              </button>
            );
          })}

          <Link
            to="/wishlist"
            className="w-full flex items-center justify-between px-4 py-3 rounded-lg text-purple-200 hover:bg-purple-700/50 transition-all"
            data-testid="sidebar-wishlist-link"
          >
            <span className="flex items-center gap-3">
              <Heart className="w-5 h-5" />
              My Wishlist
            </span>
            {wishlistCount > 0 && (
              <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                {wishlistCount}
              </span>
            )}
          </Link>

          {isShopOwner && (
            <Link
              to="/admin"
              className="w-full flex items-center justify-between px-4 py-3 rounded-lg text-yellow-400 bg-yellow-500/10 hover:bg-yellow-500/20 transition-all border border-yellow-500/30"
              data-testid="sidebar-admin-link"
            >
              <span className="flex items-center gap-3">
                <BarChart3 className="w-5 h-5" />
                Analytics Dashboard
              </span>
              <ChevronRight className="w-4 h-4" />
            </Link>
          )}

          <button
            onClick={onLogout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-red-400 hover:bg-red-500/20 transition-all"
            data-testid="logout-btn"
          >
            <LogOut className="w-5 h-5" />
            Sign Out
          </button>
        </nav>
      </CardContent>
    </Card>
  );
};
